import { Component } from '@angular/core';
import { ContactUsComponent } from '../contact-us.component';

@Component({
    selector: 'contact-us-es',
    templateUrl: './contact-us-es.component.html',
})
export class ContactUsEsComponent extends ContactUsComponent {}
